import {
  DASHBOARD_DETAILS_SUCCESS,
  DASHBOARD_DETAILS_FAILED,
  DASHBOARD_DETAILS_INVALID_REQUEST,
  RESET_DASHBOARD_DETAILS,
  NETWORK_ERROR_DASHBOARD_DETAILS
} from "../types";

const initialState = {
  failed: false,
  invalidRequest: false,
  success: false,
  data: {},
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_DETAILS_FAILED:
      return {
        ...state,
        success: false,
        invalidRequest: false,
        failed: true,
        data: action.payload,
        networkError: ""
      };

    case DASHBOARD_DETAILS_INVALID_REQUEST:
      return {
        ...state,
        success: false,
        invalidRequest: true,
        failed: false,
        data: action.payload,
        networkError: ""
      };

    case DASHBOARD_DETAILS_SUCCESS:
      return {
        ...state,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
        networkError: ""
      };

    case NETWORK_ERROR_DASHBOARD_DETAILS:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong..Check network connectivity"
      };

    case RESET_DASHBOARD_DETAILS:
      return (state = initialState);

    default:
      return state;
  }
};
